import * as yup from 'yup';
import { WidgetsDTO } from '../AccountPerformanceReporting/api/useWidgetsQuery';
import { WidgetSlugDTO } from './api/useDefaultTemplateQuery';

export interface FormValues {
  id: string | null;
  name: string;
  widgets: Record<WidgetSlugDTO, WidgetsDTO>;
}

export const validation = yup.object().shape({
  name: yup
    .string()
    .required('Template name is required')
    .max(40, 'Template name cannot exceed 40 characters'),
});

export const GAINLOSS_TAB_MAP = [
  {
    name: 'Unrealized Gain Loss',
    slug: 'UnRealizedGainLoss',
  },
  {
    name: 'Realized Gain Loss',
    slug: 'RealizedGainLoss',
  },
] as { name: string; slug: 'UnRealizedGainLoss' | 'RealizedGainLoss' }[];
